// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".billWallet[data-v-4d10fecf]{display:flex;flex-direction:column;align-items:center;justify-content:center;margin:1rem}.billButton[data-v-4d10fecf]{margin-top:1rem;padding:.5rem 1rem;border:none;border-radius:.5rem;background-color:#20b2aa;color:#fff;font-weight:700;cursor:pointer}", ""]);
// Exports
module.exports = exports;
